//generalAnalytics index
import React, { useEffect } from 'react'

import ChartCard from 'components/ChartCard'
import RevenueOverview from './components/RevenueOverview'
import { Col, Row,Spin } from 'antd'

import MonthlyAnalysis from 'components/AreaChart'

import RecentActivities from 'components/ActivitiesList'
import { DataGetAction } from 'redux/actions/http'
import { useDispatch, useSelector } from 'react-redux'
import IntlMessages from "util/IntlMessages"
const Index = () => {

    const dispatch = useDispatch();
    const adminProps = useSelector(state => state.adminDashboard)
    const { dashboardData,fetchingLoader,monthlyAnalysis } = adminProps
    
    const fetchAdminDashboard = () => {
        dispatch(DataGetAction('getAdminDashboard', '', 'gettingAdminDashboard'));
        dispatch(DataGetAction('getMonthlyOverview', '', 'gettingMonthlyOverview'));
        
        
    }
    useEffect(fetchAdminDashboard, [])






    const Data = [
        { name: 'Page A', price: 200 },
        { name: 'Page B', price: 1200 },
        { name: 'Page C', price: 600 },
        { name: 'Page D', price: 1600 },
        { name: 'Page D', price: 1000 },
        { name: 'Page H', price: 2260 },
        { name: 'Page K', price: 800 },
    ];

    // const inspectionData = [
    //     { name: '', totalSales: 200 },
    //     { name: 'JAN', totalSales: 400 },
    //     { name: 'FEB', totalSales: 150 },
    //     { name: 'MAR', totalSales: 400 },
    //     { name: 'APR', totalSales: 1000 },
    //     { name: 'MAY', totalSales: 400 },
    //     { name: 'JUN', totalSales: 1200 },
    //     { name: 'JUL', totalSales: 1000 },
    //     { name: 'AUG', totalSales: 800 },
    //     { name: 'SEP', totalSales: 750 },
    //     { name: 'OCT', totalSales: 1500 },
    //     { name: 'NOV', totalSales: 1000 },
    //     { name: 'DEC', totalSales: 1500 },
    //     { name: '', totalSales: 500 },
    // ];

    const recentActivities = [
        {
            id: 1,
            name: 'Mila Alba',
            desc: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Corrupti, quae?',
            url: "https://picsum.photos/50",
        },
        {
            id: 2,
            name: 'Bob Builder',
            desc: 'Lorem ipsum dolor sit amet.',
            url: "https://picsum.photos/50",
        },
        {
            id: 3,
            name: 'Tom Moody',
            desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
            url: "https://picsum.photos/50",
        },
        {
            id: 4,
            name: 'Norman Dolphi',
            desc: 'Norman Dolphi is looking for a house in New Jersy, USA',
            url: 'https://picsum.photos/50',
        },
        {
            id: 5,
            name: 'Bob Builder',
            desc: 'Lorem ipsum dolor sit amet.',
            url: "https://picsum.photos/50",
        },
        {
            id: 6,
            name: 'Tom Moody',
            desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
            url: "https://picsum.photos/50",
        },
        {
            id: 7,
            name: 'Norman Dolphi',
            desc: 'Norman Dolphi is looking for a house in New Jersy, USA',
            url: 'https://picsum.photos/50',
        }
    ];


    return (
        <>

{fetchingLoader ?
                <Spin size="large" color="blue" />
                : 
    <>
            <Row>
                <Col xl={6} lg={6} md={6} sm={6} xs={6}>
                    
                    <ChartCard count={(dashboardData.length && dashboardData[0].activeUser) || 0} desc={<IntlMessages id="dashboard.activeUser" />} Data={Data} bgColor={'#FCEAF4'} borderColor={'#F8C8E3'} />
                </Col>
                <Col xl={6} lg={6} md={6} sm={6} xs={6}>
                    <ChartCard count={(dashboardData.length &&dashboardData[0].freeUser) || 0} desc={<IntlMessages id="dashboard.freeUser" />} Data={Data} bgColor={'#E3F7D7'} borderColor={'#B8E986'} />
                </Col>
                <Col xl={6} lg={6} md={6} sm={6} xs={6}>
                    <ChartCard count={(dashboardData.length &&dashboardData[0].premiumUser) || 0} desc={<IntlMessages id="dashboard.premiumUser" />} Data={Data} bgColor={'#F3ECF9'} borderColor={'#C39FDF'} />
                </Col>
                <Col xl={6} lg={6} md={6} sm={6} xs={6}>
                    <ChartCard count={(dashboardData.length &&dashboardData[0].totalSale) || 0} desc={<IntlMessages id="dashboard.totalSales" />} Data={Data} bgColor={'#e5eef5'} borderColor={'#6aafe6'} />
                </Col>
            </Row>

            <Row>
                <Col xl={18} lg={18} md={12} sm={24} xs={24}>
                    <Row>
                        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                            <RevenueOverview noOfClients={12} noOfSites={5} />
                        </Col>
                    </Row>

                    
                    
                    <Row>
                        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                            <MonthlyAnalysis data={monthlyAnalysis} title={<IntlMessages id="dashboard.monthlyAnalysis" />}  width={'100%'} height={180} axisX={'name'} axisY={['Total Sale', 'freeUser', ' activeUser', 'premiumUser']}  showYAxis={true} />
                        </Col>
                    </Row>
                </Col>
                <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                    <div className="recent-activity-container">
                        <RecentActivities recentActivity={recentActivities} showImage={false} title={<IntlMessages id="dashboard.notifications" />} />
                    </div>
                </Col>
            </Row>
        </>
}
       </>
    )
}

export default Index
